var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#2A7F77"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 23.2812C32.6823 23.2812 30.4166 23.9685 28.4894 25.2562C26.5623 26.5439 25.0603 28.3741 24.1733 30.5154C23.2863 32.6568 23.0543 35.013 23.5064 37.2862C23.9586 39.5594 25.0747 41.6475 26.7136 43.2864C28.3525 44.9253 30.4406 46.0414 32.7138 46.4936C34.987 46.9457 37.3433 46.7137 39.4846 45.8267C41.6259 44.9397 43.4561 43.4377 44.7438 41.5106C46.0315 39.5835 46.7188 37.3177 46.7188 35C46.7153 31.8931 45.4795 28.9144 43.2825 26.7175C41.0856 24.5205 38.1069 23.2848 35 23.2812ZM45.7705 34.5312H40.1492C40.0391 30.5177 38.516 26.8382 35.9082 24.2574C38.5189 24.4815 40.9589 25.6474 42.7735 27.5377C44.588 29.428 45.6532 31.9136 45.7705 34.5312ZM35 45.316C32.4549 42.9289 30.9064 39.3061 30.7892 35.4688H39.2108C39.0936 39.3059 37.5451 42.9288 35 45.316ZM30.7892 34.5312C30.9064 30.6939 32.4547 27.0712 35 24.684C37.5453 27.0712 39.0936 30.6939 39.2108 34.5312H30.7892ZM34.0918 24.2574C31.484 26.8382 29.9609 30.5177 29.8508 34.5312H24.2295C24.3468 31.9136 25.412 29.428 27.2265 27.5377C29.0411 25.6474 31.4811 24.4815 34.0918 24.2574ZM24.2295 35.4688H29.8508C29.9609 39.4822 31.484 43.1618 34.0918 45.7426C31.4811 45.5185 29.0411 44.3526 27.2265 42.4623C25.412 40.572 24.3468 38.0864 24.2295 35.4688ZM35.9082 45.7426C38.516 43.1618 40.0391 39.4822 40.1492 35.4688H45.7705C45.6532 38.0864 44.588 40.572 42.7735 42.4623C40.9589 44.3526 38.5189 45.5185 35.9082 45.7426Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNet);
export default __webpack_public_path__ + "static/media/net.4347efd38847b1b76721766b4a6e0753.svg";
export { ForwardRef as ReactComponent };